<template>
  <div class="officePage-phone">
    <phoneNav/>
    <div class="select-cont">
      <div class="select-location">
        <dl>
          <dt>城市</dt>
          <dd>
            <a
                    v-for="city in cityList"
                    :key="city.id"
                    :class="{ active: selectedCity == city.name }"
                    @click="handleCityClick(city)"
            >{{ city.name }}</a
            >
          </dd>
        </dl>
      </div>
      <div class="select-project">
        <dl>
          <dt>项目</dt>
          <dd>
            <a :class="{ active: selectedProject == null }" @click="changeProject(null)"
            >不限</a
            >
            <a
                    v-for="p in projectList"
                    :key="p.id"
                    :class="{ active: selectedProject == p.projectName }"
                    @click="changeProject(p)"
            >{{ p.projectName }}</a
            >
          </dd>
        </dl>
      </div>
      <div class="select-area">
        <dl>
          <dt>面积</dt>
          <dd>
            <a :class="{ active: selectArea == null }" @click="changeArea(null)"
            >不限</a
            >
            <a
                    v-for="a in areaList"
                    :key="a.id"
                    :class="{ active: selectArea == a.name }"
                    @click="changeArea(a)"
            >{{ a.name }}</a
            >
          </dd>
        </dl>
      </div>
      <div class="select-rent">
        <dl>
          <dt>租金</dt>
          <dd>
            <a :class="{ active: selectRent == null }" @click="changeRent(null)"
            >不限</a
            >
            <a
                    v-for="r in rentList"
                    :key="r.id"
                    :class="{ active: selectRent == r.name }"
                    @click="changeRent(r)"
            >{{ r.name }} 元/m²/天</a
            >
          </dd>
        </dl>
      </div>
    </div>

    <Row class="office-cont">
      <Col span="24" class="office-list">
        <Tabs type="line" @on-click="clickTab">
          <TabPane
                  v-for="(tab, index) in tabList"
                  :key="index"
                  :label="tab.label"
                  :name="tab.name"
          >
          </TabPane>
        </Tabs>
        <OfficeListPhone
                :areaRanges="areaRanges"
                :cityIds="cityIds"
                :projectIds="projectIds"
                :rentPriceRanges="rentPriceRanges"
                :orderByType="orderByType"
        ></OfficeListPhone>
      </Col>
    </Row>
    <FooterPhone/>
  </div>
</template>

<script>
// @ is an alias to /src
import OfficeListPhone from "@/components/OfficeListPhone.vue";
import phoneNav from "../../components/phoneNav";
import FooterPhone from "../../components/FooterPhone";
export default {
  name: "AboutView",
  components: {
    OfficeListPhone,
    phoneNav,
    FooterPhone,
  },
  data() {
    return {
      theme1: "light",
      tabList: [
        {
          label: "默认排序",
          name: "0",
          icon: "",
        },
        {
          label: "价格排序",
          name: "1",
          icon: "md-arrow-round-up",
        },
        {
          label: "面积排序",
          name: "2",
          icon: "md-arrow-round-up",
        },
      ],
      loading: false,
      saving: false,
      cityList: [],
      projectList: [],
      areaList: [],
      rentList: [],
      AMap: null,
      map: null,
      selectedCity: null,
      selectedProject: null,
      selectArea: null,
      selectRent: null,
      areaRanges: [],
      cityIds: [],
      projectIds: [],
      rentPriceRanges: [],
      orderByType: 0,
      defaultCenter: null,
    };
  },
  methods: {
    getCityList() {
      this.loading = true;
      this.$http
        .get("/api/services/app/CommonWeb/GetCountryPlaceList?parentId=0")
        .then((res) => {
          this.cityList = res.data.result;
          if(this.cityList.length>0){
            this.handleCityClick(this.cityList[0]);
          }
        })
        .finally(() => {
          this.loading = false;
        });
    },
    getProjectList() {
      this.loading = true;
      return this.$http
        .get("/api/services/app/CommonWeb/GetProjectListByCityName?cityName="+this.selectedCity)
        .then((res) => {
          this.projectList = res.data.result;
        })
        .finally(() => {
          this.loading = false;
        });
    },
    getAreaList() {
      this.loading = true;
      this.$http
        .get("/api/services/app/CommonWeb/GetDicitonaryItems?dicitionaryName=租赁面积")
        .then((res) => {
          this.areaList = res.data.result;
        })
        .finally(() => {
          this.loading = false;
        });
    },
    getRentList() {
      this.loading = true;
      this.$http
        .get("/api/services/app/CommonWeb/GetDicitonaryItems?dicitionaryName=租金")
        .then((res) => {
          this.rentList = res.data.result;
        })
        .finally(() => {
          this.loading = false;
        });
    },
    handleCityClick(result) {
      console.log(result);
      let vm=this;
      if (result == null) {
        this.selectedCity = null;
        return;
      }
      let cityName = result.name;
      this.cityIds = [result.id];
      this.selectedCity = cityName;
      this.getProjectList();
    },
    changeProject(result) {
      if (result != null) {
        this.selectedProject = result.projectName;
        this.projectIds = [result.crmProjectId];
      } else {
        this.selectedProject = null;
        this.projectIds = [];
      }
    },
    changeArea(result) {
      console.log(result);
      if (result != null) {
        this.selectArea = result.name;
        this.areaRanges = [result.description];
      } else {
        this.selectArea = null;
        this.areaRanges = [];
      }
    },
    changeRent(result) {
      console.log(result);
      if (result != null) {
        this.selectRent = result.name;
        this.rentPriceRanges = [result.description];
      } else {
        this.selectRent = null;
        this.rentPriceRanges = [];
      }
    },
    clickTab(result) {
      console.log(result);
      this.orderByType = parseInt(result);
    },
  },
  mounted() {
    this.getCityList();
    this.getAreaList();
    this.getRentList();
    this.orderByType = 0;
  },
};
</script>

<style lang="less">
.officePage-phone {
  background-color: #fff;
  width:100%;
  /*padding-bottom: 120px;*/
  .select-cont {
    display: block;
    width: 100%;
    border-bottom: 1px solid #e3e3e3;
    font-size: 12px;
    padding-top:50px;


    [class^="select-"] {
      /*height: 54px;*/
      /*line-height: 54px;*/

      dl {
        width: 100%;
        display: flex;
        flex-flow: row;
        justify-items: left;
        align-items: flex-start;
        padding-bottom:5px;

        dt {
          width: 100px;
          text-align: center;
          flex:1;
          padding-top:5px
        }

        dd {
          flex: 4;
          a {
            display: inline-block;
            color: #333;
            /*width: 100px;*/
            text-align: left;
            padding: 3px 15px 3px 0;
          }

          a.active {
            color: #7b9de3;
          }
        }
      }
    }
    .select-project{
      margin-top:5px;
    }
    .select-location {
      border-bottom: 1px solid #e3e3e3;
    }
  }

  .office-cont {
    .office-list {
      padding:0 10px;
      .ivu-tabs-bar {
        border-bottom: none;
        margin-bottom:10px;

      }
      .ivu-tabs-nav-container{
        font-size:12px;
      }
      .ivu-tabs-nav .ivu-tabs-tab-active {
        color: #7b9de3;
      }

      .ivu-tabs-ink-bar {
        background-color: #00b0ec;
      }
    }

    .office-map {
      padding-top: 40px;
      padding-left: 20px;
      .map-cont {
        position: relative;
        .circle {
          position: absolute;
          background-color: rgba(18, 114, 164, 0.85);
          color: #fff;
          text-align: center;
          width: 88px;
          height: 88px;
          border-radius: 50%;

          p {
            font-size: 28px;
            padding-top: 20px;
            padding-bottom: 5px;
            line-height: 1;
          }
        }
      }
    }
  }
}
</style>
